import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M22.192 1.814a3.63 3.63 0 0 0-5.157.035L2.57 16.31.75 23.25l6.942-1.819L22.157 6.97a3.63 3.63 0 0 0 .035-5.156m-5.571.449 5.122 5.12m-7.211-3.032 5.122 5.12"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m2.57 16.31 3.59 1.532 1.536 3.584m9.397-14.515L6.16 17.841"
    }, null, -1)
  ]));
}
const interfaceEditToolPencil = { render };
export {
  interfaceEditToolPencil as default,
  render
};
//# sourceMappingURL=interface-edit-tool-pencil.svg.js.map
